import { z } from "zod";

import { MIME_TYPES } from "~/shared/file";
import { File as ZodFile } from "~/shared/zod";

const zImageMimeType = z.enum([MIME_TYPES.gif, MIME_TYPES.jpeg, MIME_TYPES.png, MIME_TYPES.svg]);

const IMAGE_MIME_TYPES = zImageMimeType.Values;

const zImageAsFile = z.instanceof(File).superRefine(ZodFile.zMimeTypeRefinement(zImageMimeType));
const zImageAsUrl = z.string().url();

export { IMAGE_MIME_TYPES, zImageAsFile, zImageAsUrl };
